var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "popup-layout",
    [
      _c(
        "template",
        { slot: "page-content" },
        [
          _vm._t("page-content", [
            _c("create-token", {
              attrs: { showTokenGeneration: "false", showExpiration: true },
              on: {
                onExpirationChanged: _vm.onExpirationChanged,
                onNamespaceChanged: _vm.onNamespaceChanged
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "row grant-row" }, [
              _vm.errorMessage
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-danger",
                      attrs: { role: "alert" }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(_vm.errorMessage) + "\n\t\t\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.authorizeApp()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-exclamation-circle fa-fw" }),
                  _vm._v(" Grant Full Access")
                ]
              )
            ])
          ])
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f514456", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f514456","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/AppAutoAuth.vue
// module id = null
// module chunks = 